module.exports = __webpack_public_path__ + "img/ba.38a248a0.svg";